import { useEffect, useState } from 'react';
import CustomInput from 'components/common/CustomInput';
import CustomButton from 'components/common/CustomButton';
import { correctPw } from 'components/common/regex';
import { ReactComponent as EyeOn } from 'assets/common/eyeOn.svg'
import { ReactComponent as EyeOff } from 'assets/common/eyeOff.svg'
import { jsonAxios } from 'components/axios';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useGetUser, userAtom } from 'atom/user';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useResetAtom } from 'jotai/utils';
import MyPageTemplate from 'components/template/MyPageTemplate';

const ResetPW = () => {
    const user = useGetUser();
    const navigate = useNavigate();
    const [originPW, setOriginPW] = useState<string>('');
    const [pw1, setPw1] = useState<string>('');
    const [pw2, setPw2] = useState<string>('');
    const [pwShow1, setPwShow1] = useState<boolean>(false);
    const [pwShow2, setPwShow2] = useState<boolean>(false);
    const [pwErrors, setPwErrors] = useState({ pw1: false, pw2: false });
    const [clear, setClear] = useState<boolean>(false);
    const [originErr, setOriginErr] = useState<boolean>(false);
    const resetUser = useResetAtom(userAtom);

    useEffect(() => {
        setOriginErr(false)
    }, [originPW]);

    useEffect(() => {
        if (pw1.length > 7 && pw2.length > 7) {
            setClear(pw1 === pw2 && !pwErrors.pw1 && !pwErrors.pw2 && originPW.trim() !== '');
        }
        else {
            setClear(false)
        }
    }, [pw1, pw2, pwErrors, originPW])

    const checkPw = (key: 'pw1' | 'pw2', pw: string) => {
        setPwErrors(prev => ({ ...prev, [key]: pw ? !correctPw(pw) : false }));
    };

    const changePW = () => {
        const reqData = {
            password: originPW
        }

        jsonAxios.post('user/password', reqData).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                resetPassword();
            }
            else if (res.data.code === 400) {
                setOriginErr(true)
            }
        })
    }

    const resetPassword = () => {
        // 비밀번호 저장하는 로직
        const reqData = {
            userId: user.id,
            newPassword: pw1
        }
        postReset(reqData).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                toast.success('비밀번호를 재설정했습니다.')
                logout();
            }
            else {
                toast.error('비밀번호 재설정에 실패했습니다.')
            }
        })
    }

    const logout = () => {
        jsonAxios.post('logout').then(res => {
            Cookies.remove("token");
            localStorage.removeItem('token')
            navigate('/', { replace: true });
            navigate('/login');
            resetUser();
        })
    }

    const postReset = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL}signin/reset`
        return await axios.post(url, reqData)
    }

    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className='flex flex-col gap-6 pt-10 tablet:pt-4 h-full min-h-dvh'>
                <div
                    className='bg-white hover:shadow-lg p-10 mobile:p-6 rounded-xl transition-all'
                >
                    <div className='flex flex-col w-[530px] mobile:w-full'>
                        <div className='flex flex-col justify-between gap-4 mobile:gap-0 w-full'>
                            <div>
                                <p className='mb-3 font-semibold mobile:text-base text-2xl'>
                                    현재 비밀번호<span className='text-red'> *</span>
                                </p>
                                <CustomInput
                                    type={'password'}
                                    value={originPW ?? ''}
                                    placeholder='현재 비밀번호를 입력해 주세요'
                                    onChange={e => setOriginPW(e.target.value)}
                                />
                                <div className='h-6'>
                                    {
                                        originErr &&
                                        <p className="text-red text-left">
                                            비밀번호가 일치하지 않습니다.
                                        </p>
                                    }
                                </div>
                            </div>

                            {[1, 2].map((num) => {
                                const isShow = num === 1 ? pwShow1 : pwShow2;
                                const setShow = num === 1 ? setPwShow1 : setPwShow2;
                                const pwKey = num === 1 ? 'password' : 'password2';
                                const pwChk = num === 1 ? pwErrors.pw1 : pwErrors.pw2;
                                const setPw = num === 1 ? setPw1 : setPw2;
                                const placeholder = num === 1 ? '새 비밀번호 입력' : '비밀번호 확인';
                                const title = num === 1 ? '새 비밀번호' : '비밀번호 확인';

                                return (
                                    <div key={num}>
                                        <p className='mb-3 font-semibold mobile:text-base text-2xl'>
                                            {title}<span className='text-red'> *</span>
                                        </p>
                                        <div className='relative mobile:mb-3 w-full h-15 mobile:h-10' key={num}>
                                            <CustomInput
                                                type={isShow ? 'text' : 'password'}
                                                value={num === 1 ? pw1 : pw2}
                                                name={pwKey}
                                                error={pwChk}
                                                placeholder={placeholder}
                                                onBlur={(e) => checkPw(num === 1 ? 'pw1' : 'pw2', e.target.value)}
                                                onChange={(e) => {
                                                    setPw(e.target.value);
                                                }}
                                            />
                                            <div
                                                className='top-0 right-6 absolute flex items-center h-full cursor-pointer'
                                                onClick={() => setShow((prev) => !prev)}
                                            >
                                                {isShow ? <EyeOn /> : <EyeOff />}
                                            </div>
                                            <div className='h-6'></div>
                                        </div>
                                    </div>
                                );
                            })}
                            <div className='mobile:mb-3 h-10 mobile:h-8'>
                                {(
                                    (pw1.length > 0 || pw2.length > 0) && (
                                        (pw1.length < 8 || pw2.length < 8) ||
                                        (pw1.length >= 8 && pw2.length >= 8 && (pwErrors.pw1 || pwErrors.pw2)) ||
                                        (pw1.length >= 8 && pw2.length >= 8 && !pwErrors.pw1 && !pwErrors.pw2 && pw1 !== pw2)
                                    )
                                ) && (
                                        <p className="h-10 mobile:h-8 text-red mobile:text-xs text-center">
                                            {(
                                                (pw1.length < 8 || pw2.length < 8) ||
                                                (pw1.length >= 8 && pw2.length >= 8 && (pwErrors.pw1 || pwErrors.pw2))
                                            ) ? (
                                                <>
                                                    비밀번호는 영문 대문자 숫자 특수문자를 포함한<br />
                                                    8자리 이상이어야 합니다.
                                                </>
                                            ) : (
                                                <>비밀번호가 일치하지 않습니다.</>
                                            )}
                                        </p>
                                    )}
                            </div>

                            <CustomButton
                                className='bg-primary !w-[200px] mobile:h-10'
                                title='변경하기'
                                disabled={!clear}
                                onClick={changePW}
                            />
                        </div>
                    </div>
                </div>
                <div
                    className='bg-white hover:shadow-lg mobile:mb-3 p-10 mobile:p-6 rounded-xl transition-all'
                >
                    <div className='flex flex-col gap-6 w-[530px] mobile:w-full'>
                        <div className='flex flex-col gap-1'>
                            <p className='mb-3 font-semibold mobile:text-base text-2xl'>
                                회원탈퇴
                            </p>
                            <div>*회원 탈퇴 관련 문의는 <a href={`mailto:help@theinsight.co.kr?subject=회원탈퇴 요청&body=아이디: ${user.username} 회원탈퇴 요청합니다.`} className='text-primary'>help@theinsight.co.kr</a>로 주시기 바랍니다.</div>
                        </div>

                    </div>
                </div>
            </div>
        </MyPageTemplate>
    )
}

export default ResetPW